import { Link } from 'react-router-dom'
import styled from 'styled-components'

import arrowIcon from '@/assets/images/arrorw1.png'
import dataBackupDeletePc from '@/assets/images/main-sec1-data-backup-delete.png'
import dataBackupDeleteMobile from '@/assets/images/main-sec1-data-backup-delete-mobile.png'
import findLostPhonePc from '@/assets/images/main-sec1-find_lost-phone.png'
import findLostPhoneMobile from '@/assets/images/main-sec1-find_lost-phone-mobile.png'
import locationCheckPc from '@/assets/images/main-sec1-location-check.png'
import locationCheckMobile from '@/assets/images/main-sec1-location-check-mobile.png'
import voiceMessagePc from '@/assets/images/main-sec1-voice-message.png'
import voiceMessageMobile from '@/assets/images/main-sec1-voice-message-mobile.png'
import { CustomSwiper } from '@/shared/components/ui/Swiper'
import useMediaQuery from '@/shared/hooks/useMediaQuery'
import { Nanum_b_size, Nanum_eb_size, Nanum_r_size, Nanum_rb_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'
import { icoSet } from '@/styles/mixins'

const MainSwiperItemSection = () => {
  const { isMobile } = useMediaQuery()

  const swiperData = [
    {
      title: '분실폰의 회수를 위한\n다양한 기능을 사용해보세요.',
      desc: '하루 가장 많은 시간을 나와 함께하는 휴대폰을 잃어버렸다면? 휴대폰분실보호가 제공하는\n다양한 기능들을 통해 빠르고 쉽게 찾아보세요.',
      imageName: 'find_lost-phone',
      alt: '분실폰 회수',
    },
    {
      title: '분실폰의 위치와 실시간 주변\n환경을 확인할 수 있습니다.',
      desc: '[분실폰 찾기]에 접속하여 분실 휴대폰의 카메라와 마이크를 실행하세요. 카메라의\n 전, 후면을 통해 실시간으로 주변 상황과 위치를 확인하고, 음성을 통해 회수 요청을\n해보세요.',
      imageName: 'location-check',
      alt: '분실폰 위치 및 실시간 주변 환경 확인',
    },
    {
      title: `분실폰의 스피커를 통해 회수요청${isMobile ? ' ' : '\n'}음성 메시지를 전달할 수 있습니다.`,
      desc: '[분실폰 찾기]에 접속하여 분실 휴대폰의 스피커로 음성 메시지를 전달 해보세요.\n무음모드로 설정되어 있어도 최대 볼륨으로 회수요청 메시지를 전달할 수 있습니다.',
      imageName: 'voice-message',
      alt: '분실폰 스피커를 통한 음성 회수 요청 기능',
    },
    {
      title: `분실폰의 데이터를 백업하고${isMobile ? ' ' : '\n'}개인정보는 안전하게 삭제해보세요.`,
      desc: '[분실폰 찾기]에 접속하여 휴대폰에 저장된 사진과 동영상, 연락처 등을 신속\n하게 백업해 보세요. 이 데이터들은 복원이 가능합니다. 또 민감한 개인정보\n는 백업 후 안전하게 삭제하세요.',
      imageName: 'data-backup-delete',
      alt: '분실폰 데이터 백업 및 개인정보 삭제',
    },
  ]

  const imageMap: Record<string, { pc: string; mobile: string }> = {
    'find_lost-phone': {
      pc: findLostPhonePc,
      mobile: findLostPhoneMobile,
    },
    'location-check': {
      pc: locationCheckPc,
      mobile: locationCheckMobile,
    },
    'voice-message': {
      pc: voiceMessagePc,
      mobile: voiceMessageMobile,
    },
    'data-backup-delete': {
      pc: dataBackupDeletePc,
      mobile: dataBackupDeleteMobile,
    },
  }

  return (
    <Section>
      <SectionHeading>
        <HeadingSwiperTitle>휴대폰을 잃어버렸나요?</HeadingSwiperTitle>
        <HeadingSwiperDesc>휴대폰분실보호로 빠르고 쉽게 찾아보세요</HeadingSwiperDesc>
      </SectionHeading>
      <SwiperWrap>
        <CustomSwiper.Wrap
          type="default"
          swiperOption={{
            loop: true,
            speed: 500,
            autoplay: {
              delay: 4700,
              disableOnInteraction: false,
            },
            slidesPerView: 1,
            pagination: {
              clickable: true,
              type: 'bullets',
            },
          }}
        >
          {swiperData.map((data, idx) => {
            const { pc, mobile } = imageMap[data.imageName]

            return (
              <CustomSwiper.Item key={idx}>
                <SwiperItemSection>
                  <SwiperTextWrap>
                    <SwiperTitle>{data.title}</SwiperTitle>
                    <SwiperDesc>{data.desc}</SwiperDesc>
                  </SwiperTextWrap>
                  <SwiperImg src={isMobile ? mobile : pc} alt={data.alt} />
                </SwiperItemSection>
              </CustomSwiper.Item>
            )
          })}
        </CustomSwiper.Wrap>
        <MoreBtn to="/intro">자세히 보기</MoreBtn>
      </SwiperWrap>
    </Section>
  )
}

export default MainSwiperItemSection

const Section = styled.section`
  padding: 60px 38px;

  ${mediaTablet} {
    padding: 72px 0;
  }
`

const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  padding-bottom: 38px;
  ${mediaTablet} {
    text-align: left;
    padding-bottom: 0;
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`

const HeadingSwiperTitle = styled.h4`
  color: var(--green);
  ${Nanum_b_size(24)}
  font-weight: 500;
  letter-spacing: -0.7px;

  ${mediaTablet} {
    ${Nanum_rb_size(14)}
  }
`
const HeadingSwiperDesc = styled.p`
  letter-spacing: -2px;
  ${Nanum_eb_size(64)}

  ${mediaTablet} {
    display: none;
  }
`

const SwiperWrap = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background-color: var(--gray-fb);

  ${mediaTablet} {
    width: 100%;
    position: static;
    left: auto;
    background-color: var(--white);
    margin: 0;
  }

  .swiper-pagination-bullets {
    display: flex;
    justify-content: center;
    gap: 0.5px;
    margin-bottom: 60px;

    ${mediaTablet} {
      margin-bottom: 0;
    }
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    gap: 0.5px;
  }
  .swiper-pagination-bullet {
    width: 144px;
    height: 4px;
    background-color: var(--gray-dd);
    border-radius: 0;
    opacity: 1;

    ${mediaTablet} {
      width: 24px;
      height: 4px;
      margin: 0 4px;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: var(--black);
  }
`
const SwiperItemSection = styled.div`
  padding-bottom: 460px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 123px;

  ${mediaTablet} {
    flex-direction: column;
    padding-top: 12px;
    padding-bottom: 384px;
    position: relative;
  }
`
const SwiperTextWrap = styled.div`
  white-space: pre-line;

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`

const SwiperTitle = styled.p`
  ${Nanum_eb_size(40)}
  letter-spacing: -2px;

  ${mediaTablet} {
    ${Nanum_rb_size(26)}
    font-weight: 800;
    line-height: 1.4;
  }
`

const SwiperDesc = styled.p`
  ${Nanum_r_size(15)}
  color: var(--gray-51);
  line-height: 1.4;
  margin-top: 32px;

  ${mediaTablet} {
    display: none;
  }
`
const MoreBtn = styled(Link)`
  ${Nanum_b_size(16)}
  padding: 14px 148px;
  border-radius: 23px;
  border: 2px solid var(--black);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: var(--white);
  position: absolute;
  position: absolute;
  z-index: 5;

  left: calc((100vw - 1200px) / 2);
  bottom: 250px;

  &:before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
    ${icoSet}
    background-image: url(${arrowIcon});
  }

  ${mediaTablet} {
    display: none;
  }
`
const SwiperImg = styled.img`
  position: absolute;
  width: 1920px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  padding-top: 38px;

  ${mediaTablet} {
    position: absolute;
    min-width: 768px;
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 50px;
  }
`
